import TemplateView from '../../../../../TemplateView'
import messageResource from '../../../../../messageResource'

export default class PriceListItem extends TemplateView {
    constructor({
        description = '',
        amount = '',
        additionalClass = ''
    }) {
        super()
        this.description = description
        this.amount = amount
        this.additionalClass = additionalClass
    }

    templateHtml() {
        return '<div class="priceItem <%=additionalClass%>">' +
               '    <div class="description"><%=description%></div>' +
               '    <div class="amount"/>' +
               '</div>'
    }

    afterRender() {
        this.find('.amount').text(messageResource.getMessage('licenses.price', [this.amount]))
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/orderSummary/PriceListItem.js